import { BsCheckCircle } from '@react-icons/all-files/bs/BsCheckCircle';
import { BsXCircle } from '@react-icons/all-files/bs/BsXCircle';

export const daysOptions = [
  { label: '1 day', value: 1 },
  { label: '7 days', value: 7 },
  { label: '14 days', value: 14 },
  { label: '30 days', value: 30 },
  { label: '60 days', value: 60 },
  { label: '90 days', value: 90 },
];

const calculatePercentage = (value1, value2) => {
  if (value2 === 0 || value1 === 0) {
    return '';
  }

  const percentage = (value1 / value2) * 100;
  return `(${parseFloat(percentage.toFixed(2))}%)`;
};

export const getTableColumns = ({ isZorbaUser }) => [
  {
    title: 'Buyer',
    key: 'buyer',
    render: ({ buyer, email, phoneNumber }) => (
      <div style={{ display: 'flex', flexDirection: 'column', rowGap: '5px' }}>
        <span>{buyer}</span>
        <span>{email}</span>
        <span>{phoneNumber}</span>
      </div>
    ),
  },
  {
    title: 'Did activate buybox?',
    key: '',
    render: ({ didActivateBuyBox }) =>
      didActivateBuyBox ? <BsCheckCircle size={20} /> : <BsXCircle size={20} />,
    align: 'center',
  },
  {
    title: 'Last login',
    key: 'lastLogin',
    render: ({ lastLogin }) => lastLogin,
  },
  {
    title: 'Deals received',
    key: 'numberOfDealsWeRequestedOffer',
    render: ({ requestedOffers }) => requestedOffers,
    sorter: (a, b) => a.requestedOffers - b.requestedOffers,
  },
  ...(isZorbaUser
    ? [
        {
          title: 'Did not respond',
          key: 'didNotRespond',
          sorter: (a, b) => a.didNotRespond - b.didNotRespond,
          render: ({ didNotRespond, requestedOffers }) =>
            `${didNotRespond} ${calculatePercentage(
              didNotRespond,
              requestedOffers,
            )}`,
        },
      ]
    : []),
  {
    title: 'Offers',
    key: 'numberOfOffers',
    sorter: (a, b) => a.offers - b.offers,
    render: ({ offers, requestedOffers }) =>
      `${offers} ${calculatePercentage(offers, requestedOffers)}`,
  },
  {
    title: 'Accepted by seller',
    key: 'acceptedOffers',
    sorter: (a, b) => a.acceptedOffers - b.acceptedOffers,
    render: ({ acceptedOffers, offersSubmittedToTheSeller }) =>
      `${acceptedOffers} ${calculatePercentage(
        acceptedOffers,
        offersSubmittedToTheSeller,
      )}`,
  },
  ...(isZorbaUser
    ? [
        {
          title: 'Rejected By Buyer',
          key: 'rejectedByBuyer',
          sorter: (a, b) => a.rejectedByBuyer - b.rejectedByBuyer,
          render: ({ rejectedByBuyer, requestedOffers }) =>
            `${rejectedByBuyer} ${calculatePercentage(
              rejectedByBuyer,
              requestedOffers,
            )}`,
        },
      ]
    : []),
];
